import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { FactureFournisseurDTO } from '@/models/FactureFournisseurDTO';
import { FactureFournisseurState } from '@/modules/FacturesFournisseurs/store/state';

export const getters: GetterTree<FactureFournisseurState, RootState> = {

    getFactures(state) : FactureFournisseurDTO[] | undefined {
        return state.factures;
    },
    getHeader(state){
        return state.tableHeader;
    },
    getFactureSort(state) {
        return state.sort;
    },
    isLoading(state) {
        return state.isLoading;
    },
    getFacturePage(state) {
        return state.page;
    },
    getFactureNumberOfPage(state) {
        return state.numberOfPage;
    },
    getFactureCount(state) {
        return state.count;
    },
    getFacturesStatusList(state) {
        return state.filtreEtat;
    },
    isXlsLoading(state) {
        return state.isXlsLoading;
    },
    getDateDebut(state) {
        return state.filtreDateDebut;
    }
};
